import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import { t } from "i18next";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const initialState = {
  name: "",
  email: "",
  message: "",
  file: null,
};

export const Career = (props) => {
  const { i18n } = useTranslation();
  const [{ name, email, message, file }, setState] = useState(initialState);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "file") {
      setState((prevState) => ({ ...prevState, file: files[0] }));
    } else {
      setState((prevState) => ({ ...prevState, [name]: value }));
    }
  };

  const clearState = () => setState({ ...initialState });

  const handleSuccess = () => {
    clearState();
    toast.success(t("emailSentSuccess") || "Email sent successfully!");
    setTimeout(() => navigate("/thank-you"), 1500);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Honeypot check
    const honeyField = e.target.honey.value;
    if (honeyField) {
      toast.error("Bot detected.");
      return;
    }

    const emailMessage = `
Name: ${name}
Email: ${email}
Message: ${message}
${file ? `File attached: ${file.name}` : ""}
`;

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64File = reader.result.split(",")[1];

        emailjs
          .send(
            "service_8hr46gh",
            "template_4wmj8wi",
            {
              name,
              email,
              message: emailMessage,
              attachments: [{ name: file.name, data: base64File }],
            },
            "GU98_tVqfo69jyFjZ"
          )
          .then(handleSuccess)
          .catch((error) => {
            console.error(error);
            toast.error(
              t("emailSentError") ||
                "Failed to send email. Please try again later."
            );
          });
      };
      reader.readAsDataURL(file);
    } else {
      emailjs
        .send(
          "service_8hr46gh",
          "template_4wmj8wi",
          { name, email, message: emailMessage },
          "GU98_tVqfo69jyFjZ"
        )
        .then(handleSuccess)
        .catch((error) => {
          console.error(error);
          toast.error(
            t("emailSentError") ||
              "Failed to send email. Please try again later."
          );
        });
    }
  };

  return (
    <div>
      <ToastContainer />
      <div id="career">
        <div className="container">
          <div className="form-holder">
            {/* Contact Info */}
            <div className="col-md-3 col-md-offset-1 contact-info">
              <div className="contact-item">
                <h3>{t("contact-info")}</h3>
                <p>
                  <span>
                    <i className="fa fa-map-marker"></i> {t("address")}
                  </span>
                  مكتب رقم 44 ، الخبر - شارع الرياض، مجمع الحصن المملكة العربية
                  السعودية
                </p>
              </div>
              <div className="contact-item">
                <p>
                  <span>
                    <i className="fa fa-phone"></i> {t("phone")}
                  </span>{" "}
                  +966 138999177
                </p>
                <p>+966 544085577</p>
              </div>
              <div className="contact-item">
                <p>
                  <span>
                    <i className="fa fa-envelope-o"></i> {t("email")}
                  </span>{" "}
                  info@gpitco.com
                </p>
              </div>
            </div>

            {/* Form */}
            <div className="col-md-8 form-right">
              <div className="row">
                <div className="section-title">
                  <h2>{t("career")}</h2>
                  <p>{t("career_text")}</p>
                </div>
                <form name="sentMessage" validate onSubmit={handleSubmit}>
                  {/* Honeypot hidden input */}
                  <input
                    type="text"
                    name="honey"
                    style={{ display: "none" }}
                    tabIndex={-1}
                    autoComplete="off"
                  />
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="email"
                          id="email"
                          name="email"
                          className="form-control"
                          placeholder={t("email")}
                          required
                          onChange={handleChange}
                          value={email}
                          dir={i18n.language === "ar" ? "rtl" : "ltr"}
                          style={{
                            textAlign:
                              i18n.language === "ar" ? "right" : "left",
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          id="name"
                          name="name"
                          className="form-control"
                          placeholder={t("name")}
                          required
                          onChange={handleChange}
                          value={name}
                          dir={i18n.language === "ar" ? "rtl" : "ltr"}
                          style={{
                            textAlign:
                              i18n.language === "ar" ? "right" : "left",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <textarea
                      name="message"
                      id="message"
                      className="form-control"
                      rows="4"
                      placeholder={t("message")}
                      required
                      onChange={handleChange}
                      value={message}
                      dir={i18n.language === "ar" ? "rtl" : "ltr"}
                      style={{
                        textAlign: i18n.language === "ar" ? "right" : "left",
                      }}
                    ></textarea>
                  </div>
                  <div className="form-group">
                    <input
                      type="file"
                      name="file"
                      className="form-control"
                      onChange={handleChange}
                      accept=".pdf,.doc,.docx,.png,.jpg,.jpeg"
                      dir={i18n.language === "ar" ? "rtl" : "ltr"}
                      style={{
                        textAlign: i18n.language === "ar" ? "right" : "left",
                      }}
                    />
                  </div>
                  <button type="submit" className="btn btn-custom btn-lg">
                    {t("submit")}
                  </button>
                </form>
              </div>
            </div>
          </div>

          {/* Social Icons */}
          <div className="col-md-12">
            <div className="row">
              {props.temp === "career-form" ? (
                <div
                  className="social"
                  style={{
                    display: "flex",
                    justifyContent:
                      i18n.language === "ar" ? "flex-end" : "flex-start",
                  }}
                >
                  <ul>
                    <li>
                      <a href={props.data ? props.data.facebook : "/"}>
                        <i className="fa fa-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a href={props.data ? props.data.twitter : "/"}>
                        <i className="fa fa-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href={props.data ? props.data.youtube : "/"}>
                        <i className="fa fa-youtube"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
